module.exports = __webpack_public_path__ + "static/media/picto-save.6ccd6abd.svg";